import { Row, Table } from 'antd';
import { useState } from 'react';
import CommonTableHeader from '../../../../components/common/CommonTableHeader';
import { expenseHeadsColumns } from '../utils/utils';
import { useAppDispatch } from '../../../../app/hooks';
import { ExpenseHeadDataType } from '../types/ExpenseHeadTypes';
import { setModal } from '../../../../common/slices/commonSlice';
import EditHeadModal from '../modals/EditHeadModal';
import AddNewHeadModal from '../modals/AddNewHeadModal';
import BreadCrumb from '../../../../components/common/breadCrumb/BreadCrumb';
import { useGetAllExpenseHeadWithPagQuery } from '../Endpoints/expenseHeadEndpoints';
import { loadingIndicator } from '../../../../components/common/spinner/LoadingIndicator';
import { perProps } from '../../../../common/types/commonTypes';

const ExpenseHead = ({ permission }: perProps) => {
  const dispatch = useAppDispatch();
  const [editInfo, setEditInfo] = useState<ExpenseHeadDataType | null>(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
  });

  const handlePaginationChange = (current: number, pageSize: number) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      current,
      pageSize,
    }));
  };

  const showModal = () => {
    dispatch(setModal(true));
  };
  const {
    isLoading,
    data: expenseHead,
    refetch,
  } = useGetAllExpenseHeadWithPagQuery(pagination, {
    selectFromResult: (cache) => {
      const data = cache.data?.data;
      const count = cache.data?.count;
      const dataToReturn: ExpenseHeadDataType[] = [];
      const exHeadNaList: string[] = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          exHeadNaList.push(element.head_name);
          dataToReturn.push({
            ...element,
            key: i + 1,
          });
        }
      }
      return { ...cache, data: { dataToReturn, exHeadNaList, count } };
    },
  });

  return (
    <div>
      <BreadCrumb
        arrOfOption={['Configuration', 'Expense Head']}
        refetch={refetch}
        reloaderSize='small'
      />
      <CommonTableHeader
        width
        align
        modalTitle={editInfo ? 'Edit Expense Head' : 'Add Expense Head'}
        title='Expense Head'
        button_text='Add New Head'
        permission={permission?.['create:any']}
        element={
          editInfo ? (
            <EditHeadModal
              exSubHeadNaList={expenseHead.exHeadNaList}
              info={editInfo}
              setNull={setEditInfo}
            />
          ) : (
            <AddNewHeadModal exHeadNaList={expenseHead.exHeadNaList} />
          )
        }
        setNull={setEditInfo}
      />
      <Row justify={'center'}>
        <Table
          size='small'
          style={{ width: 900 }}
          bordered
          pagination={
            expenseHead?.count !== undefined && expenseHead?.count < 20
              ? false
              : {
                ...pagination,
                total: expenseHead?.count,
                showSizeChanger: true,
                pageSizeOptions: ['50', '100', '200', '500'],
                onChange: handlePaginationChange,
              }
          }
          columns={expenseHeadsColumns({
            setEditInfo,
            showModal,
            permission,
            pagination,
          })}
          dataSource={expenseHead.dataToReturn}
          scroll={{ x: true }}
          loading={{ spinning: isLoading, indicator: loadingIndicator }}
        />
      </Row>
    </div>
  );
};

export default ExpenseHead;
